import {createRouter, createWebHistory} from 'vue-router';
import store from "@/store";
import PageIndexSix from '../pages/PageIndexSix';
import PageLogin from '../pages/auth/PageLogin';
import Reviews from "@/pages/Admin/Reviews/Reviews.vue";
import ReviewForm from "@/pages/Admin/Reviews/ReviewForm.vue";
import AppLayout from "@/components/AppLayout.vue";
import NotFound from "@/pages/NotFound.vue";
import YouTubeVideos from "@/pages/Admin/YouTubeVideos/YouTubeVideos.vue";
import YouTubeVideosForm from "@/pages/Admin/YouTubeVideos/YouTubeVideosForm.vue";
import Galleries from "@/pages/Admin/Gallery/Galleries.vue";
import GalleryForm from "@/pages/Admin/Gallery/GalleryForm.vue";
import ReviewShow from "@/pages/Admin/Reviews/ReviewShow.vue";
import Dashboard from "@/pages/Admin/Dashboard/Dashboard.vue";

const routes = [
    {
        path: '/',
        name: 'HomeIndex',
        component: PageIndexSix,
    },
    {
        path: "/dashboard",
        name: "app",
        component: AppLayout,
        meta: {
            requireAuth: true,
        },
        children: [
            {
                path: '',
                name: 'app.dashboard',
                component: Dashboard,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'reviews',
                name: 'app.reviews',
                component: Reviews,
                meta: {
                    requireAuth: true
                }
            },

            {
                path: '/reviews/create',
                name: 'app.reviews.create',
                component: ReviewForm
            },
            {
                path: '/reviews/:id',
                name: 'app.reviews.edit',
                component: ReviewForm
            },
            {
                path: 'reviews/show/:id',
                name: 'app.reviews.show',
                component: ReviewShow
            },
            {
                path: "youtube-videos",
                name: "app.youtube-videos",
                component: YouTubeVideos
            },
            {
                path: "youtube-videos/create",
                name: "app.youtube-videos.create",
                component: YouTubeVideosForm
            },
            {
                path: "youtube-videos/:id",
                name: "app.youtube-videos.edit",
                component: YouTubeVideosForm
            },
            {
                path: "galleries",
                name: "app.galleries",
                component: Galleries
            },
            {
                path: "galleries/create",
                name: "app.galleries.create",
                component: GalleryForm
            },
            {
                path: "galleries/:id",
                name: "app.galleries.edit",
                component: GalleryForm
            },
        ]
    },
    {
        path: '/dashboard/login',
        name: 'login',
        component: PageLogin,
        meta: {
            requireAuth: false
        }
    },
    {
        path: "/:pathMatch(.*)",
        name: "notfound",
        component: NotFound,
    },

];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.meta.requireAuth && !store.state.user.token) {
        next({name: "login"});
    } else if (to.meta.requireGuest && store.state.user.token) {
        next({name: "app.dashboard"});
    } else {
        next();
    }
});
export default router;